import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState(null);

  useEffect(() => {
    // Counter animation
    const animateCounters = () => {
      const counters = document.querySelectorAll(".count");
      counters.forEach((counter) => {
        const target = parseInt(counter.textContent);
        let current = 0;
        const increment = target / 100;
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            counter.textContent =
              target + (counter.textContent.includes("%") ? "%" : "");
            clearInterval(timer);
          } else {
            counter.textContent =
              Math.floor(current) +
              (counter.textContent.includes("%") ? "%" : "");
          }
        }, 20);
      });
    };

    // Trigger counter animation when section is visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounters();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    const successSection = document.querySelector(".success-section");
    if (successSection) {
      observer.observe(successSection);
    }

    // Testimonial slider
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 6);
    }, 5000);

    return () => {
      clearInterval(slideInterval);
      observer.disconnect();
    };
  }, []);

  const testimonials = [
    {
      id: 0,
      video: "https://www.youtube.com/watch?v=bTKUX-WEBt4",
      image: "/assets/images/reviews/klokbox/klokbox.png",
      name: "Daniel Culloty",
      role: "CEO, Klokbox",
      avatar: "/assets/images/reviews/klokbox/user.jpg",
      linkedin: "https://www.linkedin.com/in/danielculloty/",
      thumbnail: "/assets/images/logos/logo-klokbox-1.svg",
    },
    {
      id: 1,
      video: "https://www.youtube.com/watch?v=MWYh9wbWv_g",
      image: "/assets/images/reviews/autobiography/autobio.png",
      name: "Arie Botbol",
      role: "CEO, Stealth Mode",
      avatar: "/assets/images/reviews/autobiography/cliant.png",
      linkedin: "https://www.linkedin.com/in/ariebotbol/",
      thumbnail: "/assets/images/reviews/autobiography/logo.png",
    },
    {
      id: 2,
      text: "Thanks to team's expertise in Flutter, our food tracker and calorie counter app for the French market has been a tremendous success. We look forward to a long-term partnership for future updates and maintenance.",
      name: "Marion Grassia",
      role: "CEO , LAISSE-TOI GUIDER",
      avatar: "/assets/images/reviews/ltg/client-ltg.jpg",
      linkedin: "https://www.linkedin.com/in/marion-grassia-85095322a/",
      thumbnail: "/assets/images/logos/logo-ltg.svg",
    },
    {
      id: 3,
      text: "Slash Star turned my team's concept of a mobile app connecting via Bluetooth and web 3.0 into an astounding reality. Their professionalism, transparent communication, development speed, and technical expertise were evident throughout the project. The end result was a seamlessly designed app that effortlessly integrates Bluetooth connectivity. For anyone seeking a dedicated development partner that transforms ideas into technological brilliance, I wholeheartedly recommend Slash Star.",
      name: "Seung Hwan Lee",
      role: "CEO, Nilo.gg",
      avatar: "/assets/images/reviews/nilo/image.png",
      linkedin: "https://www.linkedin.com/in/seungh-lee/",
      thumbnail: "/assets/images/logos/nilo-orignal.svg",
    },
    {
      id: 4,
      text: "We were able to successfully complete the project by meeting the best partner. They have a very good understanding of development and skills, and are fully committed to the task schedule. The time we met and spent with them is lucky for us. We'll always work on the project with them.",
      name: "Min Suk Kim",
      role: "CEO, Nine Peace Co. Ltd.",
      avatar: "/assets/images/reviews/finutzz/user.jpg",
      linkedin: "https://www.linkedin.com/in/min-suk-kim-9040311b2/",
      thumbnail: "/assets/images/logos/logo-finutss-1.svg",
    },
    {
      id: 5,
      text: "The team delivered a super functional product, within an impressive timeframe, that has stood the test of time through the growth of our user base. They have been extremely responsive all throughout.",
      name: "Karen Zhao",
      role: "Co-founder, Telly",
      avatar: "/assets/images/reviews/telly/client-telly.jpg",
      linkedin: "https://www.linkedin.com/in/karenzhao2/",
      thumbnail: "/assets/images/logos/dark-telly.svg",
    },
  ];

  const handleAccordionClick = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="home-page">
      <section className="intro-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>

          <div className="container hero-container">
            <div className="home-hero-section">
              <h1 className="wow fadeInUp home-title" data-wow-delay="0.3s">
                <span className="gradient-text">AI-Empowered</span>
                <br /> Software Development Company
              </h1>
            </div>
          </div>
        </div>

        <div className="companies">
          <div className="container">
            <div className="title-line">
              <span>
                Trusted by <strong>150 + Companies</strong> and growing
              </span>
            </div>
            <div className="flex logos grayscale">
              <img src="/assets/images/logos/logo-wom.svg" alt="Wom" />
              <img
                src="/assets/images/logos/logo-leosphere.svg"
                alt="Leosphere"
              />
              <img
                src="/assets/images/logos/logo-home-depot-orange.webp"
                alt="Home Depo"
              />
              <img
                src="/assets/images/logos/logo-cashback-white.svg"
                alt="My Cashback"
              />
              <img src="/assets/images/logos/logo-linde.webp " alt="Linde" />
              <img src="/assets/images/logos/logo-nilo.svg" alt="Nilo" />
              <img src="/assets/images/logos/pwr.svg" alt="PWR" />
              <img src="/assets/images/logos/klokbox.png" alt="Klokbox" />
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Case Studies</span>
          </div>
          <div className="title row">
            <div className="col col-6 wow fadeInUp">
              <h2>
                <span className="gradient-text">Success stories</span> - See how
                we’ve helped our clients
              </h2>
            </div>
            <div className="col col-6 wow fadeInUp">
              <p>
                We help companies and startups to build efficient digital
                products with a human-first approach through proper UX &
                interaction design.
              </p>
              <Link to="/portfolio" className="btn btn-shadow">
                VIEW ALL <span className="arrow"></span>
              </Link>
            </div>
          </div>
          <div className="portfolio card-deck-js wow fadeInUp">
            <div className="portfolio-card">
              <Link to="/the-home-depot">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/depo.svg"
                      alt="The Home Depo"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>The Home Depot</h3>
                      <div>
                        <span>Ui/Ux</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-8" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/klokbox">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/klokbox.svg"
                      alt="Klokbox"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Klokbox</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img
                        src="/assets/images/icon/arrow.svg"
                        alt="arrow icon"
                      />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/deltra">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/deltra.svg"
                      alt="Deltra"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Deltra </h3>
                      <div>
                        <span>Ui/Ux</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img
                        src="/assets/images/icon/arrow.svg"
                        alt="best arrow"
                      />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img
                        src="/assets/images/icon/arrow.svg"
                        alt="top arrow"
                      />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img
                        src="/assets/images/icon/arrow.svg"
                        alt="black arrow"
                      />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img
                        src="/assets/images/icon/arrow.svg"
                        alt="icon arrow"
                      />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div id="cursor">
            <div className="cursor-circle"></div>
          </div>
        </div>
      </section>

      <section className="success-section">
        <div className="container wow fadeInUp">
          <div className="flex-space-between">
            <div className="flex-item">
              <h2>
                <span className="count">8</span>+
              </h2>
              <p>Years of Experience</p>
            </div>
            <div className="flex-item">
              <h2>
                <span className="count">110</span>+
              </h2>
              <p>
                Digital Solutions
                <br />
                Delivered
              </p>
            </div>
            <div className="flex-item">
              <h2>
                <span className="count">12</span>+
              </h2>
              <p>Industries Served</p>
            </div>
            <div className="flex-item">
              <h2>
                <span className="count">92</span>%
              </h2>
              <p>Client Retention Rate</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - truncated for brevity, full version would include all services */}
      <section className="services-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Services</span>
          </div>
          <div className="title row wow fadeInUp">
            <div className="col col-6">
              <h2>
                A <span className="gradient-text">one-stop-shop</span> for your
                digital products
              </h2>
            </div>
            <div className="col col-6">
              <p>
                As a versatile software engineering company, we're capable of
                assisting you at any development phase. Whether you're building
                your product from the ground up, updating it, or consistently
                refining it, our team possesses the necessary skills to elevate
                your business.
              </p>
            </div>
          </div>

          {/* Desktop Services - Full implementation would include all 6 services */}
          <div className="services wow fadeInUp desktop-service">
            <Link to="/product-design">
              <div className="card">
                <div className="service-data">
                  <h3>01.</h3>
                  <div>
                    <h3>Product Design</h3>
                    <p>
                      Our product design services bring your ideas to life with
                      captivating logo design, cohesive branding, and intuitive
                      UI/UX for both mobile and web applications. We create
                      visually stunning and user-friendly designs that resonate
                      with your audience and elevate your brand.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img src="/assets/images/icon/icon-figma.svg" alt="Figma" />
                    <img
                      src="/assets/images//icon/icon-adobe-xd.svg"
                      alt="Adobe Xd"
                    />
                    <img
                      src="/assets/images/icon/icon-adobe -illustrator.svg"
                      alt="Adobe Ai"
                    />
                    <img
                      src="/assets/images/icon/icon-adobe-photoshop.svg"
                      alt="Photoshop"
                    />
                    <img
                      src="/assets/images/icon/icon-sketch.svg"
                      alt="Sketch"
                    />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="Arrow-9"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="Arrow-10"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* Mobile Development */}
            <Link to="/mobile-development">
              <div className="card">
                <div className="service-data">
                  <h3>02.</h3>
                  <div>
                    <h3>Mobile Development</h3>
                    <p>
                      We specialize in crafting high-performance mobile
                      applications that are tailored to your needs. Our team
                      develops native and cross-platform apps that offer
                      seamless user experiences and cutting-edge functionality,
                      ensuring your business stays ahead in the mobile-first
                      world.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img
                      src="/assets/images/icon/icon-android.svg"
                      alt="android"
                    />
                    <img
                      src="/assets/images/icon/icon-ios-color.svg"
                      alt="ios-color"
                    />
                    <img
                      src="/assets/images/icon/icon-flutter.svg"
                      alt="flutter"
                    />
                    <img src="/assets/images/icon/icon-react.svg" alt="react" />
                    <img
                      src="/assets/images/icon/icon-flutter-flow.svg"
                      alt="flutter-flow"
                    />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="Arrow-16"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="Arrow-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* Web Development */}
            <Link to="/web-development">
              <div className="card">
                <div className="service-data">
                  <h3>03.</h3>
                  <div>
                    <h3>Web Development</h3>
                    <p>
                      Our web app development services provide robust, scalable,
                      and responsive solutions. We build interactive web
                      applications that deliver superior performance and user
                      engagement, leveraging the latest technologies to meet
                      your business objectives.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img src="/assets/images/icon/icon-react.svg" alt="react" />
                    <img
                      src="/assets/images/icon/icon-angular.svg"
                      alt="angular"
                    />
                    <img src="/assets/images/icon/icon-vue.svg" alt="vue" />
                    <img
                      src="/assets/images/icon/icon-shopify.svg"
                      alt="shopify"
                    />
                    <img
                      src="/assets/images/icon/icon-wordpress.svg"
                      alt="wordpress"
                    />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="Arrow-11"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="Arrow-12"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* Backend Development */}
            <Link to="/backend-development">
              <div className="card">
                <div className="service-data">
                  <h3>04.</h3>
                  <div>
                    <h3>Backend Development</h3>
                    <p>
                      Our backend development services focus on creating secure,
                      efficient, and scalable server-side solutions. We handle
                      data management, API integrations, and server
                      configurations to ensure your application runs smoothly
                      and reliably, supporting your business operations.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img
                      src="/assets/images/icon/icon-java-springboot.svg"
                      alt="Java Springboot"
                    />
                    <img src="/assets/images/icon/icon-node.svg" alt="Node" />
                    <img
                      src="/assets/images/icon/icon-python.svg"
                      alt="Python"
                    />
                    <img src="/assets/images/icon/icon-aws.svg" alt="Aws" />
                    <img src="/assets/images/icon/icon-azure.svg" alt="Azure" />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="service-arrow-black"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="service-arrow-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* Blockchain Development */}
            <Link to="/blockchain-development">
              <div className="card">
                <div className="service-data">
                  <h3>05.</h3>
                  <div>
                    <h3>Blockchain Development</h3>
                    <p>
                      We offer comprehensive blockchain development services to
                      revolutionize your business processes. From smart
                      contracts to decentralized applications (DApps), our
                      expertise in blockchain technology ensures transparency,
                      security, and efficiency in your digital transactions.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img
                      src="/assets/images/icon/icon-ethereum.svg"
                      alt="ethereum"
                    />
                    <img
                      src="/assets/images/icon/icon-polygon-matic.svg"
                      alt="polygon matic"
                    />
                    <img
                      src="/assets/images/icon/icon-solidity-light.svg"
                      alt="solidity"
                    />
                    <img
                      src="/assets/images/icon/icon-python.svg"
                      alt="python"
                    />
                    <img
                      src="/assets/images/icon/icon-node-js.svg"
                      alt="node"
                    />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="Arrow-14"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="service-arrow-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>

            {/* AI Development */}
            <Link to="/ai-development">
              <div className="card">
                <div className="service-data">
                  <h3>06.</h3>
                  <div>
                    <h3>AI Development</h3>
                    <p>
                      Harness the power of artificial intelligence with our AI
                      development services. We build intelligent systems that
                      learn, adapt, and provide valuable insights, helping you
                      automate processes, enhance decision-making, and deliver
                      personalized experiences to your users.
                    </p>
                  </div>
                </div>
                <div className="service-icons">
                  <div className="design-icon">
                    <img
                      src="/assets/images/icon/ai-development/icon-chatgpt-white.svg"
                      alt="ChatGPT"
                    />
                    <img
                      src="/assets/images/icon/ai-development/icon-claude-ai-white.svg"
                      alt="Claude-AI"
                    />
                    <img
                      src="/assets/images/icon/ai-development/icon-dall-e.svg"
                      alt="Dall-E"
                    />
                    <img
                      src="/assets/images/icon/ai-development/icon-gemini.svg"
                      alt="Gemini"
                    />
                    <img
                      src="/assets/images/icon/ai-development/icon-midjourny.svg"
                      alt="Midjourny"
                    />
                  </div>
                  <div className="url-path">
                    <div>
                      <img
                        className="service-arrow-black"
                        src="/assets/images/icon/arrow.svg"
                        alt="Arrow-15"
                      />
                      <img
                        className="service-arrow-white"
                        src="/assets/images/icon/arrow-white.svg"
                        alt="Arrow-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Mobile Accordion Services */}
          <div className="accordions accordions-service">
            <div
              className={`accordions-title service-accordions-title ${
                activeAccordion === 0 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(0)}
            >
              <h3>01. Product Design</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content ${
                activeAccordion === 0 ? "active" : ""
              }`}
            >
              <p>
                Our product design services bring your ideas to life with
                captivating logo design, cohesive branding, and intuitive UI/UX
                for both mobile and web applications. We create visually
                stunning and user-friendly designs that resonate with your
                audience and elevate your brand.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img src="/assets/images/icon/icon-figma.svg" alt="Figma" />
                  <img
                    src="/assets/images//icon/icon-adobe-xd.svg"
                    alt="Adobe Xd"
                  />
                  <img
                    src="/assets/images/icon/icon-adobe -illustrator.svg"
                    alt="Adobe Ai"
                  />
                  <img
                    src="/assets/images/icon/icon-adobe-photoshop.svg"
                    alt="Photoshop"
                  />
                  <img src="/assets/images/icon/icon-sketch.svg" alt="Sketch" />
                </div>
                <Link to="/product-design">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="Arrow-3"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="Arrow-4"
                    />
                  </div>
                </Link>
              </div>
            </div>

            {/* Mobile Development */}
            <div
              className={`accordions-title service-accordions-title ${
                activeAccordion === 1 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(1)}
            >
              <h3>02. Mobile Development</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content ${
                activeAccordion === 1 ? "active" : ""
              }`}
            >
              <p>
                We specialize in crafting high-performance mobile applications
                that are tailored to your needs. Our team develops native and
                cross-platform apps that offer seamless user experiences and
                cutting-edge functionality, ensuring your business stays ahead
                in the mobile-first world.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img
                    src="/assets/images/icon/icon-android.svg"
                    alt="android"
                  />
                  <img
                    src="/assets/images/icon/icon-ios-color.svg"
                    alt="ios-color"
                  />
                  <img
                    src="/assets/images/icon/icon-flutter.svg"
                    alt="flutter"
                  />
                  <img src="/assets/images/icon/icon-react.svg" alt="react" />
                  <img
                    src="/assets/images/icon/icon-flutter-flow.svg"
                    alt="flutter-flow"
                  />
                </div>
                <Link to="/mobile-development">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="Arrow-4"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="arrow-white"
                    />
                  </div>
                </Link>
              </div>
            </div>

            {/* Web Development */}
            <div
              className={`accordions-title service-accordions-title ${
                activeAccordion === 2 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(2)}
            >
              <h3>03. Web Development</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content ${
                activeAccordion === 2 ? "active" : ""
              }`}
            >
              <p>
                Our web app development services provide robust, scalable, and
                responsive solutions. We build interactive web applications that
                deliver superior performance and user engagement, leveraging the
                latest technologies to meet your business objectives.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img src="/assets/images/icon/icon-react.svg" alt="react" />
                  <img
                    src="/assets/images/icon/icon-angular.svg"
                    alt="angular"
                  />
                  <img src="/assets/images/icon/icon-vue.svg" alt="vue" />
                  <img
                    src="/assets/images/icon/icon-shopify.svg"
                    alt="shopify"
                  />
                  <img
                    src="/assets/images/icon/icon-wordpress.svg"
                    alt="wordpress"
                  />
                </div>
                <Link to="/web-development">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="arrow-black"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="arrow-white"
                    />
                  </div>
                </Link>
              </div>
            </div>

            {/* Backend Development */}
            <div
              className={`accordions-title service-accordions-title ${
                activeAccordion === 3 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(3)}
            >
              <h3>04. Backend Development</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content ${
                activeAccordion === 3 ? "active" : ""
              }`}
            >
              <p>
                Our backend development services focus on creating secure,
                efficient, and scalable server-side solutions. We handle data
                management, API integrations, and server configurations to
                ensure your application runs smoothly and reliably, supporting
                your business operations.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img
                    src="/assets/images/icon/icon-java-springboot.svg"
                    alt="Java Springboot"
                  />
                  <img src="/assets/images/icon/icon-node.svg" alt="Node" />
                  <img src="/assets/images/icon/icon-python.svg" alt="Python" />
                  <img src="/assets/images/icon/icon-aws.svg" alt="Aws" />
                  <img src="/assets/images/icon/icon-azure.svg" alt="Azure" />
                </div>
                <Link to="/backend-development">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="black-Arrow"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="Arrow-white"
                    />
                  </div>
                </Link>
              </div>
            </div>

            {/* Blockchain Development */}
            <div
              className={`accordions-title service-accordions-title ${
                activeAccordion === 4 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(4)}
            >
              <h3>05. Blockchain Development</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content ${
                activeAccordion === 4 ? "active" : ""
              }`}
            >
              <p>
                We offer comprehensive blockchain development services to
                revolutionize your business processes. From smart contracts to
                decentralized applications (DApps), our expertise in blockchain
                technology ensures transparency, security, and efficiency in
                your digital transactions.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img
                    src="/assets/images/icon/icon-ethereum.svg"
                    alt="ethereum"
                  />
                  <img
                    src="/assets/images/icon/icon-polygon-matic.svg"
                    alt="polygon matic"
                  />
                  <img
                    src="/assets/images/icon/icon-solidity-light.svg"
                    alt="solidity"
                  />
                  <img src="/assets/images/icon/icon-python.svg" alt="python" />
                  <img src="/assets/images/icon/icon-node-js.svg" alt="node" />
                </div>
                <Link to="/blockchain-development">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="Arrow-6"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="Arrow-white"
                    />
                  </div>
                </Link>
              </div>
            </div>

            {/* AI Development */}
            <div
              className={`accordions-title service-accordions-title accordions-title-last ${
                activeAccordion === 5 ? "active" : ""
              }`}
              onClick={() => handleAccordionClick(5)}
            >
              <h3>06. AI Development</h3>
              <span></span>
            </div>
            <div
              className={`accordions-content accordions-content-last ${
                activeAccordion === 5 ? "active" : ""
              }`}
            >
              <p>
                Harness the power of artificial intelligence with our AI
                development services. We build intelligent systems that learn,
                adapt, and provide valuable insights, helping you automate
                processes, enhance decision-making, and deliver personalized
                experiences to your users.
              </p>
              <div className="service-icons">
                <div className="design-icon">
                  <img
                    src="/assets/images/icon/ai-development/icon-chatgpt-black.svg"
                    alt="ChatGPT"
                  />
                  <img
                    src="/assets/images/icon/ai-development/icon-claude-ai-black.svg"
                    alt="Claude-AI"
                  />
                  <img
                    src="/assets/images/icon/ai-development/icon-dall-e.svg"
                    alt="Dall-E"
                  />
                  <img
                    src="/assets/images/icon/ai-development/icon-gemini.svg"
                    alt="Gemini"
                  />
                  <img
                    src="/assets/images/icon/ai-development/icon-midjourny.svg"
                    alt="Midjourny"
                  />
                </div>
                <Link to="/ai-development">
                  <div>
                    <img
                      className="service-arrow-black"
                      src="/assets/images/icon/arrow.svg"
                      alt="arrow-black"
                    />
                    <img
                      className="service-arrow-white"
                      src="/assets/images/icon/arrow-white.svg"
                      alt="white-Arrow"
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Expertise Section */}
      <section className="timeline-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Industry Expertise</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              Our <span className="gradient-text">Spheres of Influence</span>:{" "}
              <br />
              Industries We Transform
            </h2>
          </div>

          <div className="industry-expertise-data wow fadeInUp">
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/business.svg"
                alt="Business"
              />
              <p>BUSINESS APP</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/finitch.svg"
                alt="Fintech"
              />
              <p>FINTECH</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/healthcare.svg"
                alt="healthcare"
              />
              <p>HEALTHCARE</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/e-commerce.svg"
                alt="E-commerce"
              />
              <p>E-COMMERCE</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/real-estate.svg"
                alt="Real Estate"
              />
              <p>REAL ESTATE</p>
            </div>
            <div className="industry-card">
              <img src="/assets/images/icon/industry/sport.svg" alt="Sports" />
              <p>SPORTS</p>
            </div>
            <div className="industry-card">
              <img src="/assets/images/icon/industry/gym.svg" alt="Fitness" />
              <p>FITNESS</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/logistic.svg"
                alt="Logistics"
              />
              <p>LOGISTICS</p>
            </div>
            <div className="industry-card">
              <img src="/assets/images/icon/industry/car.svg" alt="e-vehicle" />
              <p>E-VEHICLE</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/traveling.svg"
                alt="travel "
              />
              <p>TRAVEL </p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/education.svg"
                alt="education"
              />
              <p>EDUCATION</p>
            </div>
            <div className="industry-card">
              <img src="/assets/images/icon/industry/iot.svg" alt="ioT" />
              <p>IoT</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/aviation.svg"
                alt="aviation"
              />
              <p>AVIATION</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/media.svg"
                alt="media & entertainment"
              />
              <p>ENTERTAINMENT</p>
            </div>
            <div className="industry-card">
              <img
                src="/assets/images/icon/industry/social.svg"
                alt="Social-networking"
              />
              <p>SOCIAL NETWORKING</p>
            </div>
          </div>
        </div>
      </section>

      {/* Platforms Section */}
      <section className="platforms-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Platforms</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              <span className="gradient-text">Digital Discovery</span> :<br />{" "}
              Explore Our Profiles
            </h2>
          </div>
          <div className="wow fadeInUp platforms-content">
            <a
              className="platforms-part dribbble"
              href="https://dribbble.com/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img
                  src="/assets/images/icon/dribbble-logo.png"
                  alt="Dribbble"
                />
              </div>
              <h2>Dribbble</h2>
            </a>
            <a
              className="platforms-part behance"
              href="https://www.behance.net/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img src="/assets/images/icon/behance-logo.png" alt="Behance" />
              </div>
              <h2>Behance</h2>
            </a>
            <a
              className="platforms-part github"
              href="https://github.com/slashstar-co"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img src="/assets/images/icon/github-logo.png" alt="GitHub" />
              </div>
              <h2>GitHub</h2>
            </a>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section className="approach-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Why Us</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              <span className="gradient-text">Your Success, Our Priority</span>:{" "}
              <br />
              Reasons to Choose Us
            </h2>
          </div>
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Expertise and Experience</h3>
                <p>
                  With a track record of successful projects across various
                  domains, we bring a wealth of knowledge and skills to the
                  table, making us the best software development company.
                </p>
              </div>
              <div>
                <h3>Tailored Solutions</h3>
                <p>
                  We understand that every project is unique, with its own set
                  of requirements and challenges. We are more of an IT solution
                  provider company.
                </p>
              </div>
              <div>
                <h3>Transparent Communication</h3>
                <p>
                  From project inception to delivery and beyond, we keep our
                  clients informed every step of the way, ensuring alignment and
                  satisfaction.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Cutting-Edge Technologies</h3>
                <p>
                  From AI to blockchain and cloud computing, we leverage the
                  most advanced tools and technologies to develop innovative
                  solutions that drive business growth and success.
                </p>
              </div>
              <div>
                <h3>Scalability & Security</h3>
                <p>
                  Whether you're a small startup or a large enterprise, we build
                  robust, scalable & secure applications that can grow with your
                  business at every stage of the development process.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Timely Delivery</h3>
                <p>
                  We understand the importance of deadlines and strive to
                  deliver projects on time, every time, without compromising on
                  quality. Our ultimate goal is client satisfaction.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Expertise and Experience</h3>
              <p>
                With a track record of successful projects across various
                domains, we bring a wealth of knowledge and skills to the table,
                making us the best software development company.
              </p>
            </div>
            <div>
              <h3>Tailored Solutions</h3>
              <p>
                We understand that every project is unique, with its own set of
                requirements and challenges. We are more of an IT solution
                provider company.
              </p>
            </div>
            <div>
              <h3>Transparent Communication</h3>
              <p>
                From project inception to delivery and beyond, we keep our
                clients informed every step of the way, ensuring alignment and
                satisfaction.
              </p>
            </div>
            <div>
              <h3>Cutting-Edge Technologies</h3>
              <p>
                From AI to blockchain and cloud computing, we leverage the most
                advanced tools and technologies to develop innovative solutions
                that drive business growth and success.
              </p>
            </div>
            <div>
              <h3>Scalability & Security</h3>
              <p>
                Whether you're a small startup or a large enterprise, we build
                robust, scalable & secure applications that can grow with your
                business at every stage of the development process.
              </p>
            </div>
            <div>
              <h3>Timely Delivery</h3>
              <p>
                We understand the importance of deadlines and strive to deliver
                projects on time, every time, without compromising on quality.
                Our ultimate goal is client satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container wow fadeInUp">
          <div className="title-small wow fadeInUp">
            <span>Testimonial</span>
          </div>
          <div className="title">
            <h2>
              <span className="gradient-text">Empowered Partnerships </span>:
              <br />
              Testimonials that Inspire
            </h2>
          </div>
          <div className="tabs">
            <div className="slider-wrapper">
              <div className="slider mySwiper">
                {testimonials.map((testimonial, index) => (
                  <div
                    key={testimonial.id}
                    className={`slide ${
                      currentSlide === index ? "active" : ""
                    }`}
                  >
                    <div className="testimonial-tabs-data">
                      {testimonial.video ? (
                        <div className="reviews-video">
                          <a
                            href={testimonial.video}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                            />
                          </a>
                        </div>
                      ) : (
                        <p>{testimonial.text}</p>
                      )}
                      <div className="client-namess">
                        <div className="client flex">
                          <div className="client-img">
                            <img
                              src={testimonial.avatar}
                              alt={testimonial.name}
                            />
                          </div>
                          <div className="client-details">
                            <h4>{testimonial.name}</h4>
                            <h5>{testimonial.role}</h5>
                          </div>
                        </div>
                        <div className="client-social">
                          <a
                            href={testimonial.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/assets/images/icon/linkedin.svg"
                              alt={testimonial.name}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="thumbnails">
              {testimonials.map((testimonial, index) => (
                <div
                  key={testimonial.id}
                  className={`thumbnail ${
                    currentSlide === index ? "active" : ""
                  }`}
                  onClick={() => setCurrentSlide(index)}
                >
                  <img src={testimonial.thumbnail} alt={`Thumb ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
